import type { PluginObject } from 'vue';
// v-dialogDrag: 弹窗拖拽

const dialogDrag = {
  bind(el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header');
    const dragDom = el.querySelector('.el-dialog');
    dialogHeaderEl.style.cssText += ';cursor:move;';
    dragDom.style.cssText += ';top:0px;';

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const getStyle = (() => {
      if ((window.document as any).currentStyle) {
        return (dom, attr) => dom.currentStyle[attr];
      } else {
        return (dom, attr) => getComputedStyle(dom)[attr];
      }
    })();

    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;

      const dragDomWidth = dragDom.offsetWidth;
      const dragDomheight = dragDom.offsetHeight;

      const screenWidth = document.body.clientWidth;
      const screenHeight = document.body.clientHeight;

      const minDragDomLeft = dragDom.offsetLeft;
      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;

      const minDragDomTop = dragDom.offsetTop;
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight;

      // 获取到的值带px 正则匹配替换
      let styL = getStyle(dragDom, 'left');
      let styT = getStyle(dragDom, 'top');

      if (styL.includes('%')) {
        styL = +document.body.clientWidth * (+styL.replaceAll('%', '') / 100);
        styT = +document.body.clientHeight * (+styT.replaceAll('%', '') / 100);
      } else {
        styL = +styL.replaceAll('px', '');
        styT = +styT.replaceAll('px', '');
      }

      document.onmousemove = (event) => {
        // 通过事件委托，计算移动的距离
        let left = event.clientX - disX;
        let top = event.clientY - disY;

        // 边界处理
        if (-left > minDragDomLeft) {
          left = -minDragDomLeft;
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft;
        }

        if (-top > minDragDomTop) {
          top = -minDragDomTop;
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop;
        }

        // 移动当前元素
        dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`;
      };

      document.onmouseup = (event) => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  },
};

const dialogDragInstall: PluginObject<any> = {
  install: (vue, options?) => {
    vue.directive('dialogDrag', dialogDrag);
  },
};

export default dialogDragInstall;

// // v-dialogDragWidth: 弹窗宽度拖大 拖小
// Vue.directive("dialogDragWidth", {
//   bind(el, binding, vnode, oldVnode) {
//     const dragDom = binding.value.$el.querySelector(".el-dialog");

//     el.onmousedown = (e) => {
//       // 鼠标按下，计算当前元素距离可视区的距离
//       const disX = e.clientX - el.offsetLeft;

//       document.onmousemove = (ev) => {
//         ev.preventDefault(); // 移动时禁用默认事件

//         // 通过事件委托，计算移动的距离
//         const l = ev.clientX - disX;
//         dragDom.style.width = `${l}px`;
//       };

//       document.onmouseup = (ev) => {
//         document.onmousemove = null;
//         document.onmouseup = null;
//       };
//     };
//   },
// });

export const hasClass = (obj, cls) => {
  return obj.className.match(new RegExp(`(\\s|^)${cls}(\\s|$)`));
};

export const addClass = (obj, cls) => {
  if (!hasClass(obj, cls)) {
    obj.className += ` ${cls}`;
  }
};

export const removeClass = (obj, cls) => {
  if (hasClass(obj, cls)) {
    const reg = new RegExp(`(\\s|^)${cls}(\\s|$)`);
    obj.className = obj.className.replace(reg, ' ');
  }
};

export const toggleClass = (obj, cls) => {
  if (hasClass(obj, cls)) {
    removeClass(obj, cls);
  } else {
    addClass(obj, cls);
  }
};

// @Component
// class Tips extends Vue {
//   functional = true;
//   content = "";
//   placement = "right-start";
//   disabled = false;
//   transition = "-";
//   trigger = "focus";
//   reference = {};
//   popperClass = "el-form-item-tips";
//   name = "";
//   errors: any;
//   getErrorMsg() {
//     return "";
//   }
//   setErrorClass(flg:boolean){
//     console.info('设置错误状态');
//   }
//   render(h): VNode {
//     this.content = this.getErrorMsg();
//     this.disabled= !this.content;
//     if(this.content){
//       this.setErrorClass(true)
//     }else{
//       this.setErrorClass(false)
//     }
//     return h("el-popover", {
//       props: {
//         ...this.$data,
//       },
//       ref: "reference",
//     });
//   }
// }
// Vue.directive("validate-tips", {
//   bind(el: HTMLElement, binding, vnode, oldVnode) {
//     const tipsContructor = Vue.extend<Tips, {}, {}, never>(Tips);
//     const tipsInstance = new tipsContructor();
//     /* 把当前组件指向 popover 的 refernce */
//     tipsInstance.reference = el;
//     tipsInstance.name = vnode.componentInstance.$attrs.name;
//     tipsInstance.getErrorMsg = getErrorMsg;
//     tipsInstance.setErrorClass = setErrorClass;
//     tipsInstance.$mount();
//     document.body.appendChild(tipsInstance.$el);

//     function getErrorMsg() {
//       const name= vnode.componentInstance.$attrs.name || vnode.componentInstance.$props.name
//       return vnode.context.errors.first(name);
//     }
//     function setErrorClass(flg:boolean){
//       if(flg){
//         addClass(el, "is-scrm-error");
//       }else{
//         removeClass(el, "is-scrm-error");
//       }
//     }
//   },
// });
